define("powergen/models/part",
  [],
  function() {
    "use strict";
    var Part;

    Part = DS.Model.extend({
      type: DS.belongsTo('partType'),
      name: DS.attr('string'),
      selected: DS.attr('boolean', {
        defaultValue: false
      })
    });


    return Part;
  });